<template>
    <div class="qr-code-container">
        <div class="main">
            <div class="img-box">
                <img :src="columnQrcode" alt="">
            </div>
            <p class="column-name">{{columnName == '首页' ? '湾潮' : columnName}}</p>
            <p class="column-info">{{columnInfo}}</p>
            <div class="follow-btn" @click="followColumn()" v-if="!isFollow">+关注</div>
            <div class="isfollow" v-else>已关注</div>
        </div>
        <!-- <div class="info">
            登录后可以保存您的浏览喜好、评论、收藏，并与APP同步
        </div> -->
    </div>
</template>
<script>
export default {
    name: 'QrCode',
    data() {
        return {
            qrcodeShow: false
        }
    },
    computed: {
        // 栏目id
        columnId() {
            return this.$store.state.nowColumnParams.columnId;
        },
        // 栏目名称
        columnName() {
            return this.$store.state.nowColumnParams.columnName;
        },
        // 栏目简介
        columnInfo() {
            return this.$store.state.nowColumnParams.columnInfo;
        },
        // 栏目二维码
        columnQrcode() {
            return this.$store.state.nowColumnParams.qrcode;
        },
        // 是否已关注栏目
        isFollow() {
            return this.$store.state.nowColumnParams.isFollow;
        },
        isLogin() {
            return this.$store.state.isLogin;
        }
    },
    methods: {
        /**
         * @function followColumn 关注栏目
         */
        followColumn() {
            if(this.isLogin) {
                this.Bus.$emit('followColumn', true);
            } else {
                // this.loginTips();
                this.Bus.$emit('loginTips', true);
            }
        },
        /**
         * @function loginTips 登录提示
         */
        loginTips() {
            this.qrcodeShow = true;
            this.getWxLoginConfig();
        },
        /**
         * @function getWxLoginConfig 获取微信登录信息
         */
        getWxLoginConfig() {
            let flag = document.body.clientWidth > 500;
            if(flag) {
                this.$axios.get(this.Urls.wxLogin).then(res => {
                    let info = res.data.result;
                    const codeInfo = new WxLogin({
                        self_redirect: false,
                        id: "wxLoginBox", 
                        appid: info.app_id, 
                        scope: info.scope, 
                        redirect_uri: info.redirect_uri,
                        state: info.state,
                        style: "",
                        href: ""
                    });
                });
            }
        },
    }
}
</script>
<style lang="scss" scoped>
@import './QrCode.scss';
</style>


// WEBPACK FOOTER //
// src/components/pc/common/qr-code/QrCode.vue